// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DEZgJ{will-change:opacity,transform;max-width:100%}.DEZgJ,.NW2PR{position:absolute;border-radius:24px}.NW2PR{width:100%;-webkit-box-shadow:0 4px 32px rgba(98,168,253,.08);box-shadow:0 4px 32px rgba(98,168,253,.08);padding:2rem;color:#0373f9;background-color:#fff}._1tl1Y{margin-bottom:.5rem;font-size:32px;font-size:2rem;font-weight:500;line-height:40px;line-height:2.5rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){._1tl1Y{font-size:1.625rem;line-height:2.03125rem}}._36a-N{font-size:16px;font-size:1rem;font-weight:400;line-height:26px;line-height:1.625rem;font-family:var(--base-font)}._3WUez{width:61.8%}._1CY2F,._3WUez{position:absolute;border-radius:24px}._1CY2F{width:89%}._1AMjk{top:16px;top:1rem}._10SqM{right:0;bottom:0}.VjOw2{top:16px;top:1rem}._1YsyP{right:0}.DJZXx{width:100%;border-radius:24px;aspect-ratio:289/186}", ""]);
// Exports
exports.locals = {
	"imageFull": "DEZgJ",
	"info": "NW2PR",
	"infoTitle": "_1tl1Y",
	"infoText": "_36a-N",
	"imageVertical": "_3WUez",
	"imageHorizontal": "_1CY2F",
	"typeOneImageLeft": "_1AMjk",
	"typeOneImageRight": "_10SqM",
	"typeTwoImageLeft": "VjOw2",
	"typeTwoImageRight": "_1YsyP",
	"fullLoading": "DJZXx"
};
module.exports = exports;
